import { AccessPermissionsEnum } from '@/router/constants';

export default [
  // Главная (root back-office)
  {
    routeName: 'main',
    text: 'leftSideMenu.main',
    icon: 'r-home',
    permissions: [AccessPermissionsEnum.CAN_READ_MAIN],
    place: 'top',
    paths: [],
    routeNames: ['main'],
  },

  // Продажи → Клиенты
  {
    routeName: 'backoffice:clients',
    text: 'leftSideMenu.backoffice.clients',
    icon: 'three-users',
    permissions: [AccessPermissionsEnum.CAN_READ_BACK_OFFICE],
    place: 'top',
    group: 'sales',
    paths: ['backoffice-clients'],
    routeNames: ['backoffice:clients'],
  },

  // Нижний блок
  {
    routeName: 'faq:default',
    text: 'leftSideMenu.faq',
    icon: 'info',
    permissions: [AccessPermissionsEnum.CAN_READ_FAQ],
    place: 'bottom',
    paths: ['faq'],
    group: 'bottom',
    routeNames: ['faq', 'faq:default', 'faq:article'],
  },
  {
    routeName: 'support',
    text: 'leftSideMenu.support',
    icon: 'gear',
    permissions: [AccessPermissionsEnum.CAN_READ_SUPPORT],
    place: 'bottom',
    paths: ['support'],
    group: 'bottom',
    routeNames: ['support', 'support:default', 'support:article'],
  },
];
